import React from 'react';
import { TextField, type TextFieldProps } from '../../base-fields/TextField';
import { useFormField } from '../../../useFormField';
import type { StripControlledProperties } from '../../../types';
import { PatternFormat } from 'react-number-format';
import { TextInput } from '../../base-controls/text-controls/TextInput';

export function PhoneNumberFormField(props: StripControlledProperties<TextFieldProps>) {
	const fieldProps = useFormField<string | null>(props);
	const onChange = async (newValue?: string) => {
		if (!newValue) {
			await fieldProps.onChange(null);
			return;
		}
		await fieldProps.onChange(newValue);
	};

	return (
		<TextField
			{...props}
			{...fieldProps}
			value={fieldProps.value ?? ''}
			customInput={
				<PatternFormat
					customInput={TextInput}
					format="(###) ###-####"
					mask="_"
					value={fieldProps.value ?? ''}
					onValueChange={values => {
						onChange(values.value);
					}}
					allowEmptyFormatting
				/>
			}
		/>
	);
}
